// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* type5 preparing plan */
.page-preparing-plan {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-preparing-plan .svg-container {
  width: 200px;
  font-size: 16px;
  margin: 0 auto;
}

.page-preparing-plan .svg-container svg #donut-ring {
  stroke: var(--gray);
}

.page-preparing-plan .svg-container svg #donut-segment {
  transform-origin: center;
  stroke: var(--green-mint);
}

.page-preparing-plan .svg-container svg #donut-hole {
  stroke: var(--green-mint);
  animation: donut1 12s linear;
}

.page-preparing-plan .svg-container svg .segment-2 {
  fill: var(--green-mint);
}

@keyframes donutfade {
  /* this applies to the whole svg item wrapper */
  0% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}

@keyframes donutfadelong {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes donut1 {
  0% {
    stroke-dasharray: 0, 100;
  }
  100% {
    stroke-dasharray: 100, 0;
  }
}

.page-preparing-plan .steps-container {
  margin-top: 30px;

  display: flex;
  flex-direction: column;
  align-items: center;

  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: #a8a8a8;
}

.page-preparing-plan .step {
  font-size: 16px;
  line-height: 25px;
  letter-spacing: -0.384px;
  background: #8189a3;
  margin-top: 12px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.page-preparing-plan .step.active {
  background: radial-gradient(87.73% 179.41% at 90.51% 91.18%, #b56bff 0%, #326bff 100%);
  -webkit-background-clip: text;
}

.page-preparing-plan .svg-container svg #percent {
  animation: donutfadelong 1s;
  font-size: 0.5em;
  line-height: 1;
  transform: translateY(0.5em);
  font-weight: bold;
}

.page-preparing-plan .review-block {
  margin: 16px 0 40px;
  border-radius: 12px;
}

.page-preparing-plan .review-block .item-reviews {
  box-shadow: 0 4px 8px 0 var(--light-gray);
  padding: 20px;
  background-color: white;
  border-radius: 20px;
}

.page-preparing-plan .review-block .item-reviews:nth-child(3) {
  margin: 8px 0;
}

.page-preparing-plan .review-block .review-title {
  margin: 20px 0;
  color: var(--orange);
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
}

.page-preparing-plan .review-block .star-container {
  display: flex;
  gap: 2px;
}

.page-preparing-plan .review-block .star-container svg {
  height: 16px;
  width: 16px;
}

.page-preparing-plan .review-block .body-text {
  margin: 12px 0;
  color: black;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
}

.page-preparing-plan .review-block .user-name {
  color: #7f89a5;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/preparing-plan.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;;EAEhB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,sFAAsF;EACtF,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* type5 preparing plan */\n.page-preparing-plan {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.page-preparing-plan .svg-container {\n  width: 200px;\n  font-size: 16px;\n  margin: 0 auto;\n}\n\n.page-preparing-plan .svg-container svg #donut-ring {\n  stroke: var(--gray);\n}\n\n.page-preparing-plan .svg-container svg #donut-segment {\n  transform-origin: center;\n  stroke: var(--green-mint);\n}\n\n.page-preparing-plan .svg-container svg #donut-hole {\n  stroke: var(--green-mint);\n  animation: donut1 12s linear;\n}\n\n.page-preparing-plan .svg-container svg .segment-2 {\n  fill: var(--green-mint);\n}\n\n@keyframes donutfade {\n  /* this applies to the whole svg item wrapper */\n  0% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes donutfadelong {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes donut1 {\n  0% {\n    stroke-dasharray: 0, 100;\n  }\n  100% {\n    stroke-dasharray: 100, 0;\n  }\n}\n\n.page-preparing-plan .steps-container {\n  margin-top: 30px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 25px;\n  color: #a8a8a8;\n}\n\n.page-preparing-plan .step {\n  font-size: 16px;\n  line-height: 25px;\n  letter-spacing: -0.384px;\n  background: #8189a3;\n  margin-top: 12px;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.page-preparing-plan .step.active {\n  background: radial-gradient(87.73% 179.41% at 90.51% 91.18%, #b56bff 0%, #326bff 100%);\n  -webkit-background-clip: text;\n}\n\n.page-preparing-plan .svg-container svg #percent {\n  animation: donutfadelong 1s;\n  font-size: 0.5em;\n  line-height: 1;\n  transform: translateY(0.5em);\n  font-weight: bold;\n}\n\n.page-preparing-plan .review-block {\n  margin: 16px 0 40px;\n  border-radius: 12px;\n}\n\n.page-preparing-plan .review-block .item-reviews {\n  box-shadow: 0 4px 8px 0 var(--light-gray);\n  padding: 20px;\n  background-color: white;\n  border-radius: 20px;\n}\n\n.page-preparing-plan .review-block .item-reviews:nth-child(3) {\n  margin: 8px 0;\n}\n\n.page-preparing-plan .review-block .review-title {\n  margin: 20px 0;\n  color: var(--orange);\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 36px;\n  text-align: center;\n}\n\n.page-preparing-plan .review-block .star-container {\n  display: flex;\n  gap: 2px;\n}\n\n.page-preparing-plan .review-block .star-container svg {\n  height: 16px;\n  width: 16px;\n}\n\n.page-preparing-plan .review-block .body-text {\n  margin: 12px 0;\n  color: black;\n  font-size: 17px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.page-preparing-plan .review-block .user-name {\n  color: #7f89a5;\n  font-size: 17px;\n  font-weight: 700;\n  line-height: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
